/* Storefront-only Thai copy for the editable footer menus. Links and menu data stay unchanged. */
(function () {
  function localizeFooter() {
    var footer = document.querySelector('footer');
    if (!footer || document.documentElement.lang !== 'th') return;

    var copy = {
      'Join Our Circle': 'สมัครรับข่าวสาร',
      'Email address': 'อีเมล',
      'Sign up': 'สมัครรับข่าวสาร',
      'SHOP': 'ช้อปสินค้า',
      'Bags': 'กระเป๋า',
      'Accessories': 'แอ็กเซสซอรีส์',
      'Jewelry': 'เครื่องประดับ',
      'Shoes': 'รองเท้า',
      'Watches': 'นาฬิกา',
      'CUSTOMER CARE': 'บริการลูกค้า',
      'Contact Us': 'ติดต่อเรา',
      'Privacy Policy': 'นโยบายความเป็นส่วนตัว',
      'About Us': 'เกี่ยวกับเรา',
      'FAQ': 'คำถามที่พบบ่อย',
      'Locations': 'สาขาของเรา'
    };

    footer.querySelectorAll('h1,h2,h3,h4,h5,h6,summary,a,label,button').forEach(function (element) {
      var value = (element.textContent || '').trim();
      var key = Object.keys(copy).find(function (item) {
        return item.toLowerCase() === value.toLowerCase();
      });
      if (key) element.textContent = copy[key];
    });

    /* Accordion headings render the same label twice (desktop + mobile spans). */
    footer.querySelectorAll('.menu__heading__default,.menu__heading__accordion').forEach(function (element) {
      var value = (element.textContent || '').trim();
      var key = Object.keys(copy).find(function (item) {
        return item.toLowerCase() === value.toLowerCase();
      });
      if (key) element.textContent = copy[key];
    });

    footer.querySelectorAll('input[placeholder], input[aria-label]').forEach(function (input) {
      if (input.placeholder === 'Email address') input.placeholder = 'อีเมล';
      if (input.getAttribute('aria-label') === 'Email address') input.setAttribute('aria-label', 'อีเมล');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', localizeFooter);
  } else {
    localizeFooter();
  }

  /* Footer blocks can be re-rendered by the theme editor. */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', localizeFooter);
  }
})();
